import { render } from "./Ask.vue?vue&type=template&id=7974333b"
import script from "./Ask.vue?vue&type=script&lang=js"
export * from "./Ask.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__